export class eventTracking {
    static SetGoogleAnalytics() {
        if (typeof window.gtag !== "undefined") {
            window.gtag('js', new Date());
            window.gtag('config', 'AW-10869827411');
        }
        else {
            console.log("Google Analytics is not initialized.")
        }
    }

    static SetKakaoPixel() {
        if (typeof window.kakaoPixel !== "undefined") {
            window.kakaoPixel('1559475486282629527').pageView();
            window.kakaoPixel('1559475486282629527').viewContent({
                tag: 'event_mbti'
            });
        }
        else {
            console.log("Kakao pixel is not initialized.")
        }
    }
}
